<template>
  <div class="content" @scroll="scrollEven">
    <div class="content1">
      <div class="content-left">
        <div class="content-type1 fadeIn">
          <div class="title-haveBg">
            <div class="bg">STARTED</div>
            <h1 class="outSide">{{ $t("feature.title") }}</h1>
          </div>
          <p class="fadeIn">{{ $t("feature.titleSecondaryTitle") }}</p>
        </div>
        <div class="image1">
          <!-- <div class="surname1 surnameImg"></div>
          <div class="surname2 surnameImg2"></div> -->
          <img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/futuer-p1.png"
            class="fromTop"
          />
        </div>

        <div class="content-type3 Fmove1">
          <div class="title-haveBg">
            <div class="bg">PROJECT</div>
            <h1 class="outSide">{{ $t("feature.title2") }}</h1>
          </div>

          <p>{{ $t("feature.titleSecondaryTitle2") }}</p>
        </div>
      </div>
      <div class="content-right">
        <div class="right-bg">
          <div class="content-type2 fadeIn">
            <h1>{{ $t("feature.title1") }}</h1>
            <p>{{ $t("feature.titleSecondaryTitle1") }}</p>
            <label
              >{{ $t("transparency") }} – {{ $t("standardization") }} –
              {{ $t("informatization") }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="content1-1">
      <div class="content-left">
        <div class="left">
          <h1 class="Fmove2">{{ $t("feature.title3") }}</h1>
          <p class="Fmove3">{{ $t("feature.titleSecondaryTitle3") }}</p>
          <!-- <div class="Fmove4">
            <img :src="left" style="margin-right: 30px" />
            <img :src="right" />
          </div> -->
        </div>
      </div>
      <div class="content-right">
        <div class="right-bg"></div>
        <div class="futuerP2">
          <!-- <div class="surname3"></div>
          <div class="surname4"></div> -->
          <img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/futuer-p2.png"
            class="surname3"
          />
        </div>
      </div>
    </div>
    <div class="content2">
      <div class="content2-text">
        <h2>{{ $t("feature.title4") }}</h2>
        <p>{{ $t("feature.titleSecondaryTitle4") }}</p>
        <router-link to="/contact">
          <!-- <div
            class="content2-button"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
          >
            {{ $t("contactUs") }}<img :src="goWhite" />
          </div> -->
          <button
            class="content2-button"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
          >
            {{ $t("contactUs") }}<img :src="goWhite" />
          </button>
        </router-link>
      </div>
    </div>
    <footer class="app-footer">
      © 2022 Emsol Maine Service Pte Ltd. All Right Reserved.
    </footer>
  </div>
</template>

<script>
import futuerP1 from "../assets/img/futuer-p1.png";
import futuerP2 from "../assets/img/futuer-p2.png";
import goWhite from "../assets/img/go-white.png";
import goBlack from "../assets/img/go-black.png";
import right from "../assets/img/rightD.png";
import left from "../assets/img/left.png";
export default {
  name: "app-contact",
  data() {
    return {
      futuerP1,
      futuerP2,
      goWhite,
      goBlack,
      right,
      left,
    };
  },
  methods: {
    mouseover(e) {
      e.target.firstElementChild.src = this.goBlack;
    },
    mouseleave(e) {
      e.target.firstElementChild.src = this.goWhite;
    },
    scrollEven(e) {
      let { scrollTop } = e.target;
      let realHeight =
        document.getElementsByClassName("content")[0].clientHeight +
        scrollTop +
        20;
      let Fmove1 = document.getElementsByClassName("Fmove1")[0];
      let Fmove2 = document.getElementsByClassName("Fmove2")[0];
      let Fmove3 = document.getElementsByClassName("Fmove3")[0];
      // let Fmove4 = document.getElementsByClassName("Fmove4")[0];
      if (Fmove1.offsetTop < realHeight) {
        Fmove1.classList.add("fadeIn");
      }
      if (Fmove2.offsetTop < realHeight) {
        Fmove2.classList.add("fadeIn");
        document.getElementsByClassName("surname3")[0].classList.add("fromTop");
        // document
        //   .getElementsByClassName("surname4")[0]
        //   .classList.add("surnameImg2");
      }
      if (
        Fmove3.offsetTop < realHeight
        // &&
        // realHeight < Fmove4.offsetTop
      ) {
        Fmove3.classList.add("fadeIn");
      }
      // if (realHeight > Fmove4.offsetTop) {
      //   Fmove4.classList.add("fadeIn");
      // }
    },
  },
};
</script>
<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  margin-top: 60px;
  overflow-y: scroll;
  overflow-x: hidden;
  .content1 {
    height: 1200px;
    display: flex;
    .content-left {
      width: 50%;
      display: flex;
      flex-direction: column;
      .content-type1 {
        padding-left: calc((100vw - 1440px) / 2);
        text-align: left;
        width: 65%;
        h1 {
          margin-bottom: 45px;
          margin-top: 87px;
          font-size: 32px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #2a2e2e;
        }
        p {
          font-size: 16px;
          font-family: Arial-Regular, Arial;
          font-weight: 400;
          color: #2a2e2e;
          line-height: 30px;
          margin-bottom: 100px;
          margin-top: 0;
        }
      }
      .image1 {
        width: 55vw;
        height: 590px;
        position: relative;
        z-index: 2;
        .surname1 {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 3;
          top: 0;
          left: 0;
          transform: scaleX(0);
          border-radius: 10px;
          background-color: rgba(241, 243, 246, 0.7);
        }
        .surname2 {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 4;
          top: 0;
          left: 0;
          transform: scaleX(0);
          border-radius: 10px;
          background-color: rgba(241, 243, 246, 1);
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content-type3 {
        opacity: 0;
        padding-left: calc((100vw - 1440px) / 2);
        text-align: left;
        width: 35%;
        h1 {
          margin-bottom: 40px;
          margin-top: 123px;
          font-size: 40px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #2a2e2e;
          // line-height: 60px;
        }
        p {
          font-size: 16px;
          font-family: Arial-Regular, Arial;
          font-weight: 400;
          color: #2a2e2e;
          line-height: 30px;
          margin-bottom: 0;
          margin-top: 0;
        }
      }
    }
    .content-right {
      width: 50%;
      .right-bg {
        height: 820px;
        width: 100%;
        background-color: #f8f9fa;
        padding-left: 192px;
        padding-top: 390px;
        text-align: left;
        .content-type2 {
          width: 61%;
          h1 {
            font-size: 40px;
            font-family: Arial-Bold, Arial;
            font-weight: bold;
            color: #2a2e2e;
            // width: 65%;
            line-height: 60px;
            margin-bottom: 36px;
            margin-top: 0;
          }
          p {
            margin-bottom: 34px;
            border-top: 1px solid #dee0e3;
            padding-top: 40px;
            width: 75%;
            margin-top: 0;
            font-size: 16px;
            font-family: Arial-Regular, Arial;
            font-weight: 400;
            color: #2a2e2e;
            line-height: 30px;
          }
          label {
            width: 85%;
            font-size: 18px;
            font-family: Arial-Bold, Arial;
            font-weight: bold;
            color: #2a358e;
          }
        }
      }
    }
  }
  .content1-1 {
    display: flex;
    margin-bottom: 120px;
    .content-left {
      width: 50%;
      padding-top: 120px;
      display: flex;
      .left {
        width: 40%;
        padding-left: calc((100vw - 1440px) / 2);
        text-align: left;
        .Fmove2 {
          opacity: 0;
        }
        .Fmove3 {
          opacity: 0;
        }
        .Fmove4 {
          opacity: 0;
        }
        h1 {
          margin-bottom: 60px;
          margin-top: 60px;
          padding-bottom: 40px;
          border-bottom: 1px solid #dee0e3;
          font-size: 32px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #2a358e;
          line-height: 60px;
        }
        p {
          font-size: 16px;
          font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
          font-weight: 400;
          color: #2a2e2e;
          line-height: 30px;
          margin-bottom: 92px;
        }
      }
    }
    .content-right {
      width: 50%;
      position: relative;
      .surname3 {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 3;
        top: 0;
        left: 0;
        transform: scaleX(0);
        border-radius: 10px;
        background-color: rgba(241, 243, 246, 0.7);
      }
      .surname4 {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 4;
        top: 0;
        left: 0;
        transform: scaleX(0);
        border-radius: 10px;
        background-color: rgba(241, 243, 246, 1);
      }
      .futuerP2 {
        position: absolute;
        right: calc((100vw - 1440px) / 2);
        top: 120px;
        z-index: 2;
        width: 943px;
        height: 590px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right-bg {
        height: 500px;
        width: 100%;
        background-color: #f8f9fa;
      }
    }
  }
  .content2 {
    margin-top: 120px;
    width: 100%;
    height: 390px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/contact.png");
    .content2-text {
      padding: 60px 240px;
      text-align: left;
      h2 {
        margin-top: 0;
        margin-bottom: 40px;
        font-size: 32px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #ffffff;
        line-height: 60px;
      }
      p {
        margin-top: 0;
        margin-bottom: 57px;
        font-size: 16px;
        font-family: Arial-Regular, Arial;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
      }
      .content2-button {
        cursor: pointer;
        padding: 9px 19px 9px 19px;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        border: 2px solid #fff;
        font-size: 16px;
        font-family: Arial-Regular, Arial;
        font-weight: Regular;
        color: #fff;
        background-clip: text;
        background-color: #111544;
        img {
          width: 16px;
          height: 16px;
          margin-left: 22px;
        }
      }
      .content2-button:hover {
        background-color: #fff;
        color: #000;
      }
    }
  }
  .title-haveBg {
    position: relative;
    .outSide {
      position: relative;
      z-index: 2;
    }
    .bg {
      position: absolute;
      top: 0;
      font-size: 58px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #f6f6f7;
      line-height: 0px;
    }
  }
}
</style>